export type ProgramDetailSections = {
  /** Prose paragraphs (non-bullet lines). */
  paragraphs: string[];
  /** Feature / acknowledgement items (bullet lines, marker stripped). */
  features: string[];
};

// A line is a bullet when it starts with -, •, or * followed by whitespace.
const BULLET = /^[-•*]\s+/;
// Strip markdown links to their label text: [BMI](https://…) → BMI.
const MARKDOWN_LINK = /\[([^\]]+)\]\([^)]*\)/g;

const clean = (line: string) => line.replace(MARKDOWN_LINK, '$1').trim();

/**
 * Splits a program's markdown detail/disclaimer copy into prose paragraphs and
 * bullet items. The backend sends `detail_description` / `group_detail_description`
 * as prose blocks followed by a `-`-prefixed feature list, and `disclaimer` as a
 * pure bullet list — both parse through this. Markdown links are flattened to
 * their label text so they read cleanly as plain `Text`.
 */
export function parseProgramDetail(text: string | null | undefined): ProgramDetailSections {
  const paragraphs: string[] = [];
  const features: string[] = [];
  if (!text) return { paragraphs, features };

  for (const raw of text.replace(/\r\n/g, '\n').split('\n')) {
    const line = raw.trim();
    if (!line) continue;
    if (BULLET.test(line)) {
      features.push(clean(line.replace(BULLET, '')));
    } else {
      paragraphs.push(clean(line));
    }
  }

  return { paragraphs, features };
}
